import { useEffect, useRef } from 'react';
import { api, getUserToken } from '@utils/api';

/**
 * Hook to send periodic heartbeat to update user's last_seen_at
 * @param {number} intervalMs - Heartbeat interval in milliseconds (default: 2 minutes)
 */
export const useHeartbeat = (intervalMs = 2 * 60 * 1000) => {
    const intervalRef = useRef(null);

    useEffect(() => {
        const token = getUserToken();
        
        if (!token) {
            // Not logged in, no heartbeat needed
            return;
        }

        const sendHeartbeat = async () => {
            try {
                await fetch(api('/api/user/heartbeat'), {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
            } catch (error) {
                // Silent fail for heartbeat
            }
        };

        // Send initial heartbeat
        sendHeartbeat();

        // Set up interval for periodic heartbeat
        intervalRef.current = setInterval(sendHeartbeat, intervalMs);

        // Cleanup on unmount
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [intervalMs]);
};

export default useHeartbeat;

